import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import "../styles/OverviewPage.css";
import GoogleBar from "./GoogleBar";
import TopSection from "./TopSection";
import WorkExperience from "./WorkExperience";
import Education from "./Education";
import FunProjects from "./FunProjects";
import AcademicProjects from "./AcademicProjects";

const OverviewPage = () => {
  const location = useLocation();
  const isStatsPage = location.pathname === "/stats";

  return (
    <div className="overview-container">
      <GoogleBar />

      {!isStatsPage && (
        <div className="main-content">
          <TopSection />
          <div className="experience-education-grid">
            <WorkExperience />
            <Education />
          </div>
          <div className="project-section">
            <AcademicProjects />
            <FunProjects />
          </div>
        </div>
      )}

      <Outlet />
    </div>
  );
};

export default OverviewPage;
